export * from './tile-demo.component';
export * from './tile-demo-tile1.component';
export * from './tile-demo-tile2.component';
